import { ProductSubscriptionReportRequestDTO } from '@iota/inh-core-v1-management-client';
import { MONTH_ENUM_BY_INDEX } from 'src/app/shared/constants-and-enums/months';

export enum ProductSubscriptionReportType {
    TERMINATIONS = 'TERMINATIONS',
    NEW = 'NEW',
    ACTIVE = 'ACTIVE'
}

export const REPORT_TYPE_LABELS: Record<ProductSubscriptionReportType, string> = {
    [ProductSubscriptionReportType.TERMINATIONS]: $localize`Subscriptions to be terminated`,
    [ProductSubscriptionReportType.NEW]: $localize`New subscriptions started`,
    [ProductSubscriptionReportType.ACTIVE]: $localize`All active subscriptions`
};

export function indexToMonthEnum(zeroBasedIndex: number): ProductSubscriptionReportRequestDTO.MonthEnum {
    return MONTH_ENUM_BY_INDEX[zeroBasedIndex];
}
